const getMessageListHead = () => {
  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: true,
      label: "ID",
      visible: false,
    },
    {
      id: "content",
      numeric: false,
      disablePadding: true,
      label: "メッセージ",
      visible: true,
      minWidth: "25rem",
    },
    {
      id: "senderRoleLabel",
      numeric: false,
      disablePadding: true,
      label: "役割",
      visible: true,
      minWidth: "1rem",
    },
    {
      id: "senderName",
      numeric: false,
      disablePadding: true,
      label: "担当者",
      visible: true,
      minWidth: "1rem",
    },
    {
      id: "createdAtFormatted",
      numeric: false,
      disablePadding: true,
      label: "送信日時",
      visible: true,
      minWidth: "1rem",
    },
  ];
  return headCells;
};
export default getMessageListHead;
